module.exports = __webpack_public_path__ + "static/media/logo-teal.013b5509.svg";